<div class="payment-methods">
  <div
    tappable
    data-cy="payment-method"
    class="payment-method with-max-width"
    (click)="onSelectPaymentClient(paymentClient)"
    *ngFor="let paymentClient of paymentClients"
    [class.not-available]="paymentClient.mov && cartTotal < paymentClient.mov"
    [class.not-selected]="
      selectedPaymentClient?.client !== paymentClient.client ||
      selectedPaymentClient?.paymentMethod !== paymentClient.paymentMethod ||
      selectedCard ||
      (isTapV3Enabled && paymentClient.client === tapPaymentClient.client && paymentClient.paymentMethod === tapPaymentClient.paymentMethod)
    "
  >
    <ion-icon class="payment-method-radio-button not-selected" name="radio-button-off-outline"></ion-icon>
    <ion-icon class="payment-method-radio-button selected" name="radio-button-on-outline"></ion-icon>

    <img class="payment-method-image" [src]="paymentClient.imageUrl" />

    <div class="payment-method-details">
      <span class="payment-method-text">{{ paymentClient.clientName | translate }}</span>
      <span *ngIf="paymentClient.message" data-cy="payment-method-message" class="payment-method-text-secondary">
        {{ paymentClient.message }}
        <ion-icon name="alert-circle" class="payment-method-text-secondary-error-icon"></ion-icon>
      </span>
      <span *ngIf="paymentClient.description" class="payment-method-text-tertiary" [innerHtml]="paymentClient.description"></span>
    </div>
  </div>

  <div tappable class="payment-method with-max-width" (click)="onSelectCard(card)" *ngFor="let card of savedCards">
    <ion-icon
      name="radio-button-off-outline"
      class="payment-method-radio-button"
      *ngIf="!selectedCard || selectedCard.cardId !== card.cardId"
    ></ion-icon>
    <ion-icon
      name="radio-button-on-outline"
      class="payment-method-radio-button selected"
      *ngIf="selectedCard && selectedCard.cardId === card.cardId"
    ></ion-icon>

    <img class="payment-method-image" *ngIf="card.cardType === 'MASTERCARD'" src="/assets/img/mastercard.png" />
    <img class="payment-method-image" *ngIf="card.cardType === 'VISA'" src="/assets/img/visa.png" />
    <img class="payment-method-image" [src]="creditCardDefaultImage" *ngIf="card.cardType !== 'MASTERCARD' && card.cardType !== 'VISA'" />

    <div class="payment-method-details">
      <span class="payment-method-text">
        {{ card.cardType ? card.cardType : ("CHECKOUT_PAGE.NEW_CARD" | translate) }}
        (*{{ card.lastFourDigits ? card.lastFourDigits : "XXXX" }})
      </span>
      <span *ngIf="card.expiryMonth && card.expiryYear" class="payment-method-text-secondary">
        {{ "CHECKOUT_PAGE.CREDIT_CARD_EXP" | translate }}
        {{ card.expiryMonth < 10 ? "0" + card.expiryMonth : card.expiryMonth }}/{{ card.expiryYear }}
      </span>
    </div>

    <ion-icon
      tappable
      class="payment-method-action-button"
      (click)="onDeleteSavedCard(card, $event)"
      src="/assets/custom-icons/b-trash.svg"
    ></ion-icon>
  </div>
</div>
